import { Image, Link } from "nystem-components";

const ViewLinkTravels = ({ model }) => (
  <Link className={`inline-flex items-center gap-3 ${model.className.join(" ")}`} to={model.href} type="link">
    <Image src="/icon/192.png" alt="" className="h-9 w-9 rounded-full" />
    {model.text}
  </Link>
);

export default ViewLinkTravels;
